module.exports = __webpack_public_path__ + "img/DSC_3013.228f0ba5.jpg";